import {Component} from '@angular/core';

@Component({
  selector: 'terms-of-use',
  templateUrl: './terms-of-use.html',
})
export class TermsOfUseCmp {
}
